import {
  Component,
  Input,
  Output,
  EventEmitter,
  Renderer2,
  OnChanges,
  SimpleChanges,
  OnDestroy,
  ContentChild,
  TemplateRef,
  inject,
} from '@angular/core';

@Component({
    selector: 'isophi-app-right-sidebar-panel',
    templateUrl: './right-sidebar-panel.component.html',
    styleUrls: ['./right-sidebar-panel.component.scss'],
    standalone: false
})
export class RightSidebarPanelComponent implements OnChanges, OnDestroy {
  @Input() visible = false;
  @Output() closeSidebar = new EventEmitter<void>();

  @ContentChild('headTemplate', { static: false }) headTemplate!: TemplateRef<any>;
  @ContentChild('contentTemplate', { static: false }) contentTemplate!: TemplateRef<any>;

  private backdropClickListener?: () => void;

  private readonly renderer = inject(Renderer2);

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['visible']) {
      if (this.visible) {
        this.renderer.addClass(document.body, 'sidebar-panel-open');
        this.addBackdropClickListener();
      } else {
        this.renderer.removeClass(document.body, 'sidebar-panel-open');
        this.removeBackdropClickListener();
      }
    }
  }

  onCloseSidebar(): void {
    this.closeSidebar.emit();
  }

  private addBackdropClickListener(): void {
    this.removeBackdropClickListener();
    const backdrop = document.querySelector('.main-navbar-backdrop');
    if (backdrop) {
      this.backdropClickListener = this.renderer.listen(backdrop, 'click', () => {
        this.onCloseSidebar();
      });
    }
  }

  private removeBackdropClickListener(): void {
    if (this.backdropClickListener) {
      this.backdropClickListener();
      this.backdropClickListener = undefined;
    }
  }

  ngOnDestroy(): void {
    this.renderer.removeClass(document.body, 'sidebar-panel-open');
    this.removeBackdropClickListener();
  }
}
